import React from "react";
import PropTypes from "prop-types";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ArrowUpwardRoundedIcon from "@mui/icons-material/ArrowUpwardRounded";
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";
import UnsortedIcon from "../../../../assets/icons/UnsortedIcon";

export default function SortToggleButtons({
  alignment,
  setAlignment
}) {

  const handleChange = (event, newAlignment) => {
    setAlignment(newAlignment);
  };

  return (
    <ToggleButtonGroup size="small"
      color="info"
      value={alignment}
      exclusive
      onChange={handleChange}
      aria-label="Platform"
    >
      <ToggleButton
        value="ascending"
        sx={{
          textTransform: "none",
          "&:hover": { backgroundColor: "transparent" }
        }}>
        <ArrowUpwardRoundedIcon sx={{ fontSize: 18 }} />Ascending</ToggleButton>
      <ToggleButton
        value="descending"
        sx={{
          textTransform: "none",
          "&:hover": { backgroundColor: "transparent" }
        }}><ArrowDownwardRoundedIcon sx={{ fontSize: 20 }} />Descending</ToggleButton>
      <ToggleButton
        value="unsorted"
        sx={{
          textTransform: "none",
          "&:hover": { backgroundColor: "transparent" }
        }}><UnsortedIcon color="black_solid.80" viewBox="-7 0 24 14" />Unsorted</ToggleButton>
    </ToggleButtonGroup>
  );
}

SortToggleButtons.propTypes = {
  setAlignment: PropTypes.func,
  alignment: PropTypes.string
};